import { StyledHeader } from "./styled";
import { StyledGlassPanel } from "../GlassPanel";
import { IChatHeaderProps } from "./types";
import { Fullscreen, FullscreenExit } from "@mui/icons-material";
import { CloseButton } from "./CloseButton";
import { ContextDocumentsButton } from "./ContextDocumentsButton";
import { IconButton } from "@mui/material";

const Header = (props: IChatHeaderProps) => {
    return (
        <StyledHeader>
            <StyledGlassPanel>
                <ContextDocumentsButton />
            </StyledGlassPanel>
            <StyledGlassPanel>
                {props.onToggleFullscreen && (
                    <IconButton
                        onClick={props.onToggleFullscreen}
                        size="medium"
                        sx={{
                            color: "neutral.lightest",
                            "&:hover": { backgroundColor: "transparent" },
                        }}
                    >
                        {props.isFullscreen ? <FullscreenExit fontSize="medium"/> : <Fullscreen fontSize="medium"/>}
                    </IconButton>
                )}
                <CloseButton onClick={props.onClose}/>
            </StyledGlassPanel>
        </StyledHeader>
    )
}

export {Header}